import { render, staticRenderFns } from "./purSuccess.vue?vue&type=template&id=72321363&"
import script from "./purSuccess.vue?vue&type=script&lang=js&"
export * from "./purSuccess.vue?vue&type=script&lang=js&"
import style0 from "./purSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports